import axios from 'axios';

interface CancelTokenRecord {
  source: axios.CancelTokenSource;
  timestamp: number;
}

const cancelTokens: Map<string, CancelTokenRecord> = new Map();

export const createCancelToken = (key: string) => {
  cancelPreviousRequest(key);
  const source = axios.CancelToken.source();
  cancelTokens.set(key, { source, timestamp: Date.now() });
  return source;
};

export const cancelPreviousRequest = (key: string): void => {
  const record = cancelTokens.get(key);
  if (record) {
    record.source.cancel(`Request cancelled: new ${key} request initiated`);
    cancelTokens.delete(key);
  }
};

export const clearAllRequests = (): void => {
  cancelTokens.forEach((record) => {
    record.source.cancel('All requests cleared');
  });
  cancelTokens.clear();
};

export const isCancellationError = (error: any): boolean => {
  return axios.isCancel(error);
};
